import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getBookAnalyses = asyncThunkWrapper({ 
  model: 'bookAnalyses', 
  action: 'getBookAnalyses', 
  func: async ({ offset = 0 }) => {
    const attributes = ['id', 'status', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get('/book_flow/book_analyses', { params });

    return response.data;
  } 
});
export const getBookAnalysis = asyncThunkWrapper({ 
  model: 'bookAnalyses', 
  action: 'getBookAnalysis', 
  func: async ({ id, cable = false }) => {
    const attributes = ['id', 'result', 'status', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/book_analyses/${id}`, { params });

    return { data: response.data, cable }
  } 
});
export const clearLocalBookAnalyses = createAction('bookAnalyses/clearLocalBookAnalyses');
export const clearLocalActiveBookAnalysis = createAction('bookAnalyses/clearLocalActiveBookAnalysis');